import React, {useState} from 'react'
import {
    Card,
    Button,
    Tabs,
    Form,
    Input,
    notification,
    Alert,
} from 'antd';
import service from "../api/FetchInterceptor";
import {useUserStore} from "../store/userStore";

const UpdatePassword = () => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false)
    const updateUser = useUserStore((state) => state.updateUser)

    const upgradePassword = (values) => {
        setLoading(true)

        service({
            method: 'POST',
            url: `update-password`,
            data: values
        }).then((response) => {
            notification.success({
                message: response.message
            })
            form.resetFields();
            updateUser({ mustChangePassword: false });
        }).catch((error) => {
            notification.error({
                message: error.response?.data?.message || 'Impossible de modifier le mot de passe.'
            })
        }).finally(() => {
            setLoading(false)
        })
    }

    return <>
        <Form form={form} onFinish={upgradePassword} layout={"horizontal"}>
            <Form.Item
                label="Nouveau mot de passe"
                name="password"
                rules={[
                    { required: true, message: 'Veuillez entrer un mot de passe.' },
                    { min: 8, message: 'Le mot de passe doit contenir au moins 8 caractères.' },
                ]}
            >
                <Input.Password />
            </Form.Item>

            <Form.Item
                name="password_confirmation"
                label="Confirmation du mot de passe"
                dependencies={['password']}
                rules={[
                    { required: true, message: 'Veuillez confirmer votre mot de passe.' },
                    ({ getFieldValue }) => ({
                        validator(_, value) {
                            if (!value || getFieldValue('password') === value) {
                                return Promise.resolve();
                            }
                            return Promise.reject(new Error('Les mots de passe ne correspondent pas.'));
                        },
                    }),
                ]}
            >
                <Input.Password />
            </Form.Item>

            <Button loading={loading} htmlType={'submit'} type={"primary"}>Modifier</Button>
        </Form>
    </>
}

const Profile = () => {
    const mustChangePassword = useUserStore((state) => state.user?.mustChangePassword)

    return (
        <>
            <div className="container my-4">
                {mustChangePassword && (
                    <Alert
                        className="mb-4"
                        type="warning"
                        showIcon
                        message="Vous devez changer votre mot de passe avant de continuer."
                    />
                )}
                <Card>
                    <Tabs
                        defaultActiveKey="updatePassword"
                        items={[
                            {
                                label: `Modification de mot de passe`,
                                key: 'update-password',
                                children: <UpdatePassword />,
                            }
                        ]}
                    />
                </Card>
            </div>
        </>
    )
}

export default Profile